module.exports = __webpack_public_path__ + "img/patient-assist.4e7bb5da.svg";